import aboutUsImg from "../assets/aboutus/aboutUsImg.svg";
import SectionHeading from "../components/shared/SectionHeading";
import TrustedBrandsCopy from "../components/home/TrustedBrandsAndCopy";
import CountUp from "react-countup";
import JourneyTimeline from "../components/about/JourneyTimeLine";
import JourneySoFar from "../components/about/JourneySoFar";
import { motion } from "framer-motion";

export default function AboutUs() {
  return (
    <div className="w-[90%] sm:w-11/12 md:w-4/5 lg:w-3/4 xl:w-[85%] mx-auto">
      {/* Hero Section */}
      <div className="my-8 mx-auto px-4 flex flex-col md:flex-row items-center gap-12 md:gap-24 max-w-6xl">
        <motion.div 
          className="md:w-1/2"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <h1 className="text-[32px] font-bold">
            <span className="text-secondary-color">About</span>{" "}
            <span className="text-primary-color">Us</span>
          </h1>
          <p className="mt-4 text-base text-gray-700 leading-relaxed">
            We are building a one-of-a-kind nurturing ecosystem for learners
            using technology and human efforts. We strive to create mutually beneficial
            partnerships. By providing a strong network, we assist learners in
            pursuing their journeys. Our approach goes beyond just offering
            mentors – we provide all the resources needed for the entire
            learning process from one milestone to the next, empowering learners
            to unlock their hidden talents and push them to be more creative.
          </p>
        </motion.div>
        <motion.div 
          className="md:w-1/2"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <div className="relative">
            <img
              src={aboutUsImg}
              alt="About Us"
              className="w-full max-w-md mx-auto"
            />
          </div>
        </motion.div>
      </div>

      {/* Companies Section */}
      <motion.section 
        className="mt-20 max-w-[1200px] mx-auto"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        <SectionHeading>
          <span className="text-primary-color">Our Companies</span>{" "}
          <span className="text-secondary-color">Reach</span>
        </SectionHeading>
        <p className="mt-3 text-center text-base font-normal text-gray-600">
          Trusted, Backed, And Powered By
        </p>
        <TrustedBrandsCopy />
      </motion.section>

      {/* Journey Section */}
      <motion.section 
        className="mt-20 max-w-[1200px] mx-auto"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.4 }}
      >
        <div className="my-12 px-4 flex flex-col items-center gap-12 md:gap-24 max-w-6xl">
          <div className="w-full text-center lg:text-left">
            <SectionHeading>
              <span className="text-primary-color">Our </span>
              <span className="text-secondary-color">Journey</span>
            </SectionHeading>
            <JourneyTimeline />
          </div>
        </div>
      </motion.section>

      {/* Stats Section */}
      <motion.section
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.6 }}
      >
        <JourneySoFar />
      </motion.section>
    </div>
  );
}

const journeyData = [
  {
    title: "2021 Founded",
    description:
      "Recognizing the challenges faced by students lacking personalized guidance and real-time education, professionals seeking opportunity guidance and personal brand development, and businesses struggling with early venture strategies, Mentorsity has stepped in to provide them all with a supportive community.",
  },
  {
    title: "220+ Companies",
    description:
      "Since its inception, Mentorsity has forged partnerships with over 220 companies, offering top-notch mentoring services to those seeking change, and the numbers are still growing.",
  },
  {
    title: "150k+ Professionals",
    description:
      "Mentorsity has positively impacted over 150,000 lives, offering personalized mentorship and tailored learning experiences to students, professionals, and businesses, fostering growth and empowerment.",
  },
];

const JourneyItem = ({ title, description }) => (
  <div className="p-4 border border-gray-200 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
    <h2 className="text-xl font-semibold mb-4 text-primary-color">{title}</h2>
    <p className="text-gray-700">{description}</p>
  </div>
);

const FounderMessage = () => (
  <div className="my-12 text-center">
    <h2 className="text-base	font-normal	 mb-4">Founder's Message</h2>
    <p className="max-w-3xl mx-auto text-lg text-gray-600">
      I believe that success follows those who follow their passion; however,
      the environment around us isn't always suited for nurturing our passions,
      keeping individuals from realizing their true potential. We always strive
      to succeed and work hard to discover what our passion is all about and how
      we can find it.
    </p>
  </div>
);

const StatisticsSection = () => (
  <div className="flex flex-col lg:flex-row justify-center items-center lg:space-x-16 mt-12">
    <div className="text-center lg:text-left flex-1 mb-8 lg:mb-0">
      <h3 className="text-xl font-semibold">
        <CountUp end={27000} duration={3} separator="," />+ Users Affected
      </h3>
    </div>
    <div className="text-center lg:text-left flex-1 mb-8 lg:mb-0">
      <h3 className="text-xl font-semibold">
        <CountUp end={290} duration={3} separator="," />+ Mentors
      </h3>
    </div>
    <div className="text-center lg:text-left flex-1">
      <h3 className="text-xl font-semibold">
        <CountUp end={8000} duration={3} separator="," />+ Mentees
      </h3>
    </div>
  </div>
);
